export const apis = {
    //Login
    LOGIN: 'auth/login',
    GET_CURRENT_LOGGED_IN_USER: 'auth/current-user',
    LOGOUT: 'auth/logout',
    MEMBER_REGISTER: 'member/add',
    ADMIN_REGISTER: 'auth/admin/register',
    ADMIN_COMPLETE_RESISTRATION: 'auth/admin/complete/profile',
    FORGOT_PASSWORD: 'password/forget-password',
    RESET_PASSWORD: 'password/reset-password',
    ACTIVATE_ACCOUNT: 'auth/activate',
    UPDATE_MY_PROFILE: 'auth/update/profile',
    CHANGE_PASSWORD: 'auth/change-password',
    
    // Admin
    ADMIN_REGISTER_TWO: 'admin/add',
};